const actions = {
  showCalls: (context, callsList) => context.commit('GET_CALLS', callsList)
};

export default {
  actions
};
